import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const selectVideoAll = createAsyncThunk("selectVideo", async (data) => {
    try {
        const response = data;
        return response;
    } catch (error) {
        return error;
    }
});

export const selectVideoById = createAsyncThunk("selectVideoById", async (id) => {
    try {
        const response = await axiosInstance.get(`/post/details/${id}/`);
        const result = response.data;
        return result;
    } catch (error) {
        return error.response.data;
    }
});

export const WatchVideo = createSlice({
    name: "WatchVideo",
    initialState: {
        videoData: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        // AccountProfile action promises
        builder.addCase(selectVideoAll.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(selectVideoAll.fulfilled, (state, action) => {
            state.videoData = action.payload;
            state.loading = false;
        });
        builder.addCase(selectVideoAll.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // selectVideoById action promises
        builder.addCase(selectVideoById.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(selectVideoById.fulfilled, (state, action) => {
            state.videoData = action.payload;
            state.loading = false;
        });
        builder.addCase(selectVideoById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default WatchVideo.reducer;
